export default {
    emailAddresses: []
}
